import { Component } from 'react';
import { Field } from 'redux-form';

import { GroupControl } from '../../../GroupField';
import MileageControl from '../Control';

export default class MileageGroupField extends Component {
  render() {
    return (
      <Field
        {...this.props}
        component={GroupControl}
        FormControl={MileageControl}
      />
    );
  }
}
